var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBasicPromotion(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10233_47093)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M54.8016 1.18337C53.63 0.0117938 51.7304 0.0117938 50.5588 1.18337L37.9214 13.8208C36.7498 14.9924 36.7498 16.8919 37.9214 18.0635C39.093 19.2351 40.9924 19.2351 42.164 18.0635L54.8016 5.42599C55.9732 4.25443 55.9732 2.35494 54.8016 1.18337Z",
    fill: "#5D89EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.0234 4.76266C29.5029 4.58082 30.017 4.50842 30.528 4.55086C30.5743 4.5547 30.6204 4.56014 30.6663 4.56718L45.9684 6.91826C46.7612 7.00102 47.5028 7.3537 48.068 7.91874C48.6328 8.48378 48.9856 9.22534 49.0684 10.0183L51.4192 25.3203C51.4264 25.3661 51.432 25.4123 51.4356 25.4585C51.478 25.9696 51.4056 26.4837 51.224 26.9631C51.0452 27.4341 50.7656 27.8599 50.4044 28.2107L24.3768 54.2383C23.4393 55.1747 22.1676 55.7015 20.8426 55.7015C19.5176 55.7015 18.2468 55.1755 17.3092 54.2391L1.74836 38.6782C-0.155119 36.7723 -0.155997 33.5165 1.74749 31.6107L27.7758 5.5823C28.1266 5.22114 28.5525 4.9413 29.0234 4.76266Z",
    fill: "#B3D5FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.972 21.1776C36.0633 21.1776 34.516 19.6303 34.516 17.7216C34.516 15.8129 36.0633 14.2656 37.972 14.2656C39.8807 14.2656 41.428 15.8129 41.428 17.7216C41.428 19.6303 39.8807 21.1776 37.972 21.1776Z",
    fill: "#5D89EA"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10233_47093"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 56,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBasicPromotion);
export default __webpack_public_path__ + "static/media/basic-promotion.45f607cc.svg";
export { ForwardRef as ReactComponent };